import { render, staticRenderFns } from "./GpsAiPanel.vue?vue&type=template&id=04850700&scoped=true"
import script from "./GpsAiPanel.vue?vue&type=script&lang=js"
export * from "./GpsAiPanel.vue?vue&type=script&lang=js"
import style0 from "./GpsAiPanel.vue?vue&type=style&index=0&id=04850700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04850700",
  null
  
)

export default component.exports